import * as React from 'react';

export default function Shower({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 16.6667 15'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0H3.33333C2.41667 0 1.66667 0.75 1.66667 1.66667V8.33333C1.66667 10.175 3.15833 11.6667 5 11.6667H10C11.8417 11.6667 13.3333 10.175 13.3333 8.33333V5.83333H15C15.9167 5.83333 16.6667 5.08333 16.6667 4.16667V1.66667C16.6667 0.75 15.9167 0 15 0ZM15 4.16667H13.3333V1.66667H15V4.16667ZM0.833333 15H14.1667C14.625 15 15 14.625 15 14.1667C15 13.7083 14.625 13.3333 14.1667 13.3333H0.833333C0.375 13.3333 0 13.7083 0 14.1667C0 14.625 0.375 15 0.833333 15Z"
        fill="currentColor"
      />
    </svg>
  );
}
